/* eslint-disable react-refresh/only-export-components */
import { MobileSearchableSelect } from '../MobileSearchableSelect';
import {
  InlineSearchableList,
  SearchableSelect,
  SearchableSelectOption,
} from '../SearchableSelect';

interface StatusFilterProps {
  selectedValues: string[];
  onChange: (values: string[]) => void;
  options?: SearchableSelectOption[];
  onClose?: () => void;
  variant?: 'inline' | 'popover' | 'mobile';
}

// Shared status options used across desktop and mobile filters
export const STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'offline', label: 'Offline' },
  { value: 'ready', label: 'Ready' },
  { value: 'ready_with_warning', label: 'Ready (Warning)' },
  { value: 'running', label: 'Running' },
  { value: 'running_with_warning', label: 'Running (Warning)' },
  { value: 'not_ready', label: 'Not Ready' },
  { value: 'busy', label: 'Busy' },
  { value: 'unknown', label: 'Unknown' },
];

export function StatusFilter({
  selectedValues,
  onChange,
  options = STATUS_OPTIONS,
  onClose,
  variant = 'inline',
}: StatusFilterProps) {
  const handleClear = () => {
    onChange([]);
  };

  if (variant === 'mobile') {
    return (
      <MobileSearchableSelect
        options={options}
        selectedValues={selectedValues}
        onSelectionChange={onChange}
        placeholder='Select statuses'
        label='Machine state'
      />
    );
  }

  if (variant === 'popover') {
    return (
      <SearchableSelect
        options={options}
        selectedValues={selectedValues}
        onSelectionChange={onChange}
        placeholder='Select statuses'
      />
    );
  }

  return (
    <InlineSearchableList
      options={options}
      selectedValues={selectedValues}
      onSelectionChange={onChange}
      placeholder='Search statuses...'
      onClearFilter={handleClear}
      onClose={onClose}
    />
  );
}
